import {
  DomainList,
  SubDomainList,
  IpAddressList,
  PortList,
  VulnerabilityList,
  SoftwareList,
  providerToDisplay,
} from '@converge/graphql';
import {
  EntitiesDomainFieldIdType,
  EntitiesDomainFieldLabelType,
  EntitiesSubdomainFieldIdType,
  EntitiesSubdomainFieldLabelType,
  EntitiesIpAddressesFieldIdType,
  EntitiesIpAddressesFieldLabelType,
  EntitiesVulnerabilitiesFieldIdType,
  EntitiesVulnerabilitiesFieldLabelType,
  EntitiesOpenPortsFieldIdType,
  EntitiesOpenPortsFieldLabelType,
  EntitiesSoftwaresFieldIdType,
  EntitiesSoftwaresFieldLabelType,
} from '@converge/data';
import { bitToYesNo } from '@converge/utils';

import { ITableColumn } from '../../../../presentation/components';

export interface IEntitiesOpenPortsUIData {
  ip?: string | null;
  protocol?: string;
  port?: number;
  isFirstRecord: boolean;
  totalRecords: number;
}

export const domainColumns: ITableColumn<DomainList, void>[] = [
  {
    id: EntitiesDomainFieldIdType.Domain,
    label: EntitiesDomainFieldLabelType.Domain,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row?.domain ?? '',
  },
  {
    id: EntitiesDomainFieldIdType.DKIM,
    label: EntitiesDomainFieldLabelType.DKIM,
    render: (row) => bitToYesNo(row?.dkim),
  },
  {
    id: EntitiesDomainFieldIdType.SPF,
    label: EntitiesDomainFieldLabelType.SPF,
    render: (row) => bitToYesNo(row?.spf),
  },
];

export const domainChildColumns: ITableColumn<SubDomainList, DomainList>[] = [
  {
    id: EntitiesSubdomainFieldIdType.Subdomain,
    label: EntitiesSubdomainFieldLabelType.Subdomain,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row?.name ?? '',
  },
  {
    id: EntitiesSubdomainFieldIdType.DMARC,
    label: EntitiesSubdomainFieldLabelType.DMARC,
    render: (row) => bitToYesNo(row?.dmarc),
  },
];

export const ipColumns: ITableColumn<IpAddressList, void>[] = [
  {
    id: EntitiesIpAddressesFieldIdType.IPAddress,
    label: 'IP address',
    render: (row) => row.ipv4Address || row.ipv6Address || 'N/A',
  },
  {
    id: EntitiesIpAddressesFieldIdType.Version,
    label: 'Version',
    render: (row) =>
      row.ipv6Address ? 'IPv6' : row.ipv4Address ? 'IPv4' : 'N/A',
  },
  {
    id: EntitiesIpAddressesFieldIdType.OpenPorts,
    label: EntitiesIpAddressesFieldLabelType.OpenPorts,
    render: (row) => 'N/A',
  },
  {
    id: EntitiesIpAddressesFieldIdType.Vulnerabilities,
    label: EntitiesIpAddressesFieldLabelType.Vulnerabilities,
    render: (row) => 'N/A',
  },
];

export const openPortsColumns: ITableColumn<PortList, void>[] = [
  {
    id: EntitiesOpenPortsFieldIdType.Port,
    label: EntitiesOpenPortsFieldLabelType.Port,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.port ?? 'N/A',
  },
  {
    id: EntitiesOpenPortsFieldIdType.Protocol,
    label: EntitiesOpenPortsFieldLabelType.Protocol,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.protocol ?? 'N/A',
  },
  {
    id: EntitiesOpenPortsFieldIdType.Source,
    label: EntitiesOpenPortsFieldLabelType.Source,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => providerToDisplay(row.source),
  },
];

export const vulnerabilitiesColumns: ITableColumn<VulnerabilityList, void>[] = [
  {
    id: EntitiesVulnerabilitiesFieldIdType.CVE,
    label: EntitiesVulnerabilitiesFieldLabelType.CVE,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.cve ?? 'N/A',
  },
  // {
  //   id: EntitiesVulnerabilitiesFieldIdType.CWE,
  //   label: EntitiesVulnerabilitiesFieldLabelType.CWE,
  //   // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
  //   render: (row) => row.cwe ?? 'N/A',
  // },
  {
    id: EntitiesVulnerabilitiesFieldIdType.Type,
    label: EntitiesVulnerabilitiesFieldLabelType.Type,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.type ?? 'N/A',
  },
  {
    id: EntitiesVulnerabilitiesFieldIdType.Score,
    label: EntitiesVulnerabilitiesFieldLabelType.Score,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.score ?? 'N/A',
  },
  {
    id: EntitiesVulnerabilitiesFieldIdType.Complexity,
    label: EntitiesVulnerabilitiesFieldLabelType.Complexity,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.complexity ?? 'N/A',
  },
  {
    id: EntitiesVulnerabilitiesFieldIdType.Authentication,
    label: EntitiesVulnerabilitiesFieldLabelType.Authentication,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.authentication ?? 'N/A',
  },
  {
    id: EntitiesVulnerabilitiesFieldIdType.Conf,
    label: EntitiesVulnerabilitiesFieldLabelType.Conf,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.conf ?? 'N/A',
  },
  {
    id: EntitiesVulnerabilitiesFieldIdType.Integ,
    label: EntitiesVulnerabilitiesFieldLabelType.Integ,
    render: (row) => row.integ ?? 'N/A',
  },
];

export const softwareColumns: ITableColumn<SoftwareList, void>[] = [
  {
    id: EntitiesSoftwaresFieldIdType.Edition,
    label: EntitiesSoftwaresFieldLabelType.Edition,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.edition ?? 'N/A',
  },
  {
    id: EntitiesSoftwaresFieldIdType.Language,
    label: EntitiesSoftwaresFieldLabelType.Language,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.language ?? 'N/A',
  },
  {
    id: EntitiesSoftwaresFieldIdType.Part,
    label: EntitiesSoftwaresFieldLabelType.Part,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.part ?? 'N/A',
  },
  {
    id: EntitiesSoftwaresFieldIdType.Product,
    label: EntitiesSoftwaresFieldLabelType.Product,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.product ?? 'N/A',
  },
  {
    id: EntitiesSoftwaresFieldIdType.Type,
    label: EntitiesSoftwaresFieldLabelType.Type,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.type ?? 'N/A',
  },
  {
    id: EntitiesSoftwaresFieldIdType.Update,
    label: EntitiesSoftwaresFieldLabelType.Update,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.update ?? 'N/A',
  },
  {
    id: EntitiesSoftwaresFieldIdType.Version,
    label: EntitiesSoftwaresFieldLabelType.Version,
    render: (row) => row.version ?? 'N/A',
  },
  {
    id: EntitiesSoftwaresFieldIdType.Source,
    label: EntitiesSoftwaresFieldLabelType.Source,
    render: (row) => providerToDisplay(row.source),
  },
  {
    id: EntitiesSoftwaresFieldIdType.Score,
    label: EntitiesSoftwaresFieldLabelType.Score,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.score ?? 'N/A',
  },
];
